import * as ACTION from 'actions'

export function addresses(state=[], action) {
    if(action == null) return  state;
    let _addresses = Object.assign([], state);
    let index = -1;

    switch (action.type) {
        case ACTION.FETCH_ADDRESS_LIST:
            return action.address;
        case ACTION.DELETE_ADDRESS:
            index = state.findIndex(data => data.winnerId === action.address.winnerId);
            _addresses.splice(index, 1);
            return _addresses;
        case ACTION.EDIT_ADDRESS:
            index = state.findIndex(data => data.winnerId === action.address.winnerId);
            _addresses[index] = action.address;
            return _addresses;
        default:
            return state
    }
}